import { useEffect, useState } from "react"

import { FieldData, mapFilters } from "@/components/_Shared/FilterWrapper"

import { useCustomerCategorySelectListQuery } from "@/hook/Dictionaries/Customers/useCustomerCategoryQuery"
import { useUsersQuery } from "@/hook/Dictionaries/useUserQuery"
import { useFilterStorage } from "@/hook/useFilterStorage"

import { CUSTOMER_CLIENTS_KEY } from "@/types/ICustomerClient"
import { FilterField, FilterFieldOperator, FilterFieldType } from "@/types/ui"


export const useCustomerClientFilters = () => {
  const [filters, setFilters] = useState<FilterField[]>([])

  const { getFilter } = useFilterStorage({
    key: CUSTOMER_CLIENTS_KEY
  })

  const { data: categories } = useCustomerCategorySelectListQuery()
  const { data: users } = useUsersQuery()

  const oldFilters: FieldData[] = getFilter()

  useEffect(() => {
    setFilters([
      ...CustomerClientFilters,
      {
          text: "ФИО ответственного лица",
          name: "ManagerId",
          type: FilterFieldType.Select,
          values: users?.response.data.map(r => ({ id: r.id, name: r.lastName + " " + r.firstName }))
      },
      {
          text: "Категория",
          name: "CustomerCategoryId",
          type: FilterFieldType.Select,
          values: categories?.response.map(r => ({ id: r.value, name: r.label }))
      }
    ])
  }, [users, categories])

  return mapFilters(filters, oldFilters)
}

const CustomerClientFilters: FilterField[] = [
  {
    text: "Название",
    name: "name",
    type: FilterFieldType.Text,
    operator: FilterFieldOperator.Contains
  }
]